module.exports = __webpack_public_path__ + "img/interpackmaxi_cod.0be04b6c.png";